import { render } from "./StateMonument.vue?vue&type=template&id=1e5fb85c"
import script from "./StateMonument.vue?vue&type=script&lang=js"
export * from "./StateMonument.vue?vue&type=script&lang=js"

import exportComponent from "E:\\vattenfall\\vattenfall-klickstrecke\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__